import { render, staticRenderFns } from "./KeiScore.vue?vue&type=template&id=55b9722e"
import script from "./KeiScore.vue?vue&type=script&lang=js"
export * from "./KeiScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports